import { useEffect } from 'react'

// Swap the favicon and apple-touch-icon hrefs on mount so each mini-app
// shows its own icon in browser tabs and on iOS home-screen bookmarks. The
// icon name matches the file under /icons/, e.g. 'todo' → /icons/todo.svg
// (desktop) and /icons/todo.png (iOS). The landing ('hewey') uses the
// brand mark at /logo.png for both (no SVG version exists).
export const useFavicon = (name: string) => {
	useEffect(() => {
		const favicon = document.getElementById(
			'favicon',
		) as HTMLLinkElement | null
		const touch = document.getElementById(
			'apple-touch-icon',
		) as HTMLLinkElement | null
		if (!favicon || !touch) return
		const prevFavicon = favicon.href
		const prevTouch = touch.href
		const isHewey = name === 'hewey'
		favicon.href = isHewey ? '/logo.png' : `/icons/${name}.svg`
		touch.href = isHewey ? '/logo.png' : `/icons/${name}.png`
		return () => {
			favicon.href = prevFavicon
			touch.href = prevTouch
		}
	}, [name])
}
